module.exports = __webpack_public_path__ + "static/media/videoBg.36247c71.png";